export const FDA_REGULATIONS_LINK: string =
  'https://www.fda.gov/regulatory-information/search-fda-guidance-documents/draft-guidance-industry-action-levels-lead-food-intended-babies-and-young-children';
